import { render, staticRenderFns } from "./ChooseRiskPointForm.vue?vue&type=template&id=b31cdaf8&scoped=true"
import script from "./ChooseRiskPointForm.vue?vue&type=script&lang=js"
export * from "./ChooseRiskPointForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31cdaf8",
  null
  
)

export default component.exports